import { auth } from "../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useEffect, useState, useCallback } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

//vanos ver se funciona//


const functions = getFunctions(undefined, "southamerica-east1");

export default function AdminExportar() {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const [role, setRole] = useState("");
  const [eventoClaim, setEventoClaim] = useState("");

  const [cpfBusca, setCpfBusca] = useState("");
  const [resultadosBusca, setResultadosBusca] = useState([]);
  const [loadingBusca, setLoadingBusca] = useState(false);

  const [codigosQR, setCodigosQR] = useState("");
  const [loadingQR, setLoadingQR] = useState(false);


  // ===== CONTADORES =====
  const [contadorVisitantes, setContadorVisitantes] = useState(0);
  const [contadorExpositores, setContadorExpositores] = useState(0);

  const [eventoId, setEventoId] = useState("");

  const [eventos, setEventos] = useState([]);
  const [eventoSelecionado, setEventoSelecionado] = useState("");


  // ================= VERIFICA ADMIN =================
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
      const idTokenResult = await user.getIdTokenResult(true);

      const claims = idTokenResult.claims;

      setIsAdmin(!!claims.admin);

      setRole(claims.role || "");

      setEventoClaim(claims.eventoId || "");

      if (claims.role === "master") {

          const snap = await getDocs(collection(db, "events"));

          const lista = snap.docs.map((d) => ({
              id: d.id,
              nome: d.data().nome || "Sem nome",
          }));

          setEventos(lista);

          if (lista.length) {
              setEventoSelecionado(lista[0].id);
              setEventoId(lista[0].id);
          }

            } else {

                const snap = await getDocs(collection(db, "events"));

                const lista = snap.docs
                    .filter(doc => doc.id === claims.eventoId)
                    .map(doc => ({
                        id: doc.id,
                        nome: doc.data().nome
                    }));

                setEventos(lista);

                if (lista.length) {
                    setEventoSelecionado(lista[0].id);
                    setEventoId(lista[0].id);
                }

            }
            } catch (error) {
              console.error(error);
              setIsAdmin(false);
            }

            setLoading(false);
          });

            return () => unsubscribe();
          }, []);

  // ================= CONTADORES =================
  const carregarContadores = useCallback(async () => {
    const eventoFinal =
      role === "master"
        ? eventoSelecionado
        : eventoClaim;
    if (!eventoFinal) return;

    try {
      const fn = httpsCallable(functions, "contarCadastros");

      const res = await fn({ eventoId: eventoFinal });

      setContadorVisitantes(res.data.visitantes ?? 0);
      setContadorExpositores(res.data.expositores ?? 0);
    } catch (err) {
      console.error("Erro ao carregar contadores", err);
    }
  }, [eventoSelecionado, eventoClaim, role]);

    useEffect(() => {

        const eventoFinal =
          role === "master"
            ? eventoSelecionado
            : eventoClaim;

        if (!eventoFinal) return;

        carregarContadores();

        const interval = setInterval(() => {
          carregarContadores();
        }, 15000);

        return () => clearInterval(interval);

    }, [
        carregarContadores,
        eventoSelecionado,
        eventoClaim,
        role
    ]);


  // ================= EXPORTAR =================
  async function exportarExcel(eventoIdParam) {
    try {
      const user = auth.currentUser;
      if (!user) return alert("Usuário não autenticado");

      const finalEvent = eventoIdParam || eventoSelecionado || eventoId;
      if (!finalEvent) return alert("Nenhum evento selecionado");

      const idToken = await user.getIdToken(true);

      const fn = httpsCallable(functions, "exportarExcelAdmin");

      const res = await fn({
        eventoId: finalEvent,
        idToken,
      });

      const base64 = res.data.file;

      const blob = new Blob(
        [Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))],
        {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }
      );

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `exportacao_${finalEvent}.xlsx`;
      a.click();
    } catch (err) {
      console.error(err);
      alert("Erro ao exportar os dados");
    }
  }

  
async function exportarContatosQR() {
  const eventoFinal =
    role === "master" ? eventoSelecionado : eventoClaim;

  if (!eventoFinal) {
    alert("Nenhum evento selecionado");
    return;
  }

  const codigos = codigosQR
    .split(/\r?\n/)
    .map((codigo) => codigo.trim())
    .filter(Boolean);

  if (!codigos.length) {
    alert("Cole os códigos QR antes de exportar");
    return;
  }

  setLoadingQR(true);

  try {
    const fn = httpsCallable(
      functions,
      "exportarContatosPorCodigo"
    );

    const res = await fn({
      eventoId: eventoFinal,
      codigos,
    });

    const base64 = res.data.file;

    const blob = new Blob(
      [
        Uint8Array.from(
          atob(base64),
          (c) => c.charCodeAt(0)
        ),
      ],
      {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }
    );

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `contatos_qr_${eventoFinal}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

  } catch (err) {
    console.error("Erro ao exportar contatos QR:", err);
    alert("Não foi possível gerar a planilha. Verifique sua permissão e tente novamente.");
  } finally {
    setLoadingQR(false);
  }
}


  // ================= BUSCAR CPF =================
async function buscarCPF() {
  const eventoFinal =
  role === "master"
    ? eventoSelecionado
    : eventoClaim;

  if (!cpfBusca || !eventoFinal) {
    alert("Evento inválido ou CPF vazio");
    return;
  }

  const cpfLimpo = cpfBusca.replace(/\D/g, "");

  if (cpfLimpo.length !== 11) {
    alert("CPF inválido");
    return;
  }

  setLoadingBusca(true);
  setResultadosBusca([]);

  try {
    const fn = httpsCallable(functions, "consultarCpf");

    const res = await fn({
      cpf: cpfLimpo,
      eventoId: eventoFinal,
    });

    const data = res.data;

    if (!data?.found) {
      setResultadosBusca([]);
      return;
    }

    setResultadosBusca([
      {
        id: cpfLimpo,
        tipo: data.tipo,
        collection:
          data.tipo === "visitante" ? "Visitantes" : "Expositores",
        ...data.data,
      },
    ]);
  } catch (err) {
    console.error(err);
    alert("Erro ao buscar CPF");
  } finally {
    setLoadingBusca(false);
  }
}

  // ================= EXCLUIR =================
    async function excluirCadastro(item) {
      const user = auth.currentUser;
      const eventoFinal =
        role === "master"
          ? eventoSelecionado
          : eventoClaim;

      if (!user || !eventoFinal) return alert("Evento inválido");

      const confirmar = window.confirm(
        `Tem certeza que deseja excluir este ${item.tipo}?`
      );

      if (!confirmar) return;

      try {
        const fn = httpsCallable(functions, "excluirCadastroAdmin");

        const res = await fn({
          id: item.id,
          collectionName: item.collection,
          eventoId: eventoFinal,
        });

        // resposta do onCall vem aqui:
        const data = res.data;

        if (!data?.ok) {
          throw new Error("Falha ao excluir");
        }

        setResultadosBusca((prev) =>
          prev.filter((r) => r.id !== item.id)
        );

      } catch (err) {
        console.error(err);
        alert(err.message || "Erro ao excluir cadastro");
      }
    }

  // ================= LOGOUT (AGORA USADO) =================
  async function handleLogout() {
    await signOut(auth);
    setIsAdmin(false);
  }

  if (loading) return <p>Carregando...</p>;
  if (!isAdmin) return <p>🔒 Acesso restrito</p>;

  return (
    <div className="page">

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button onClick={handleLogout}>
          Sair
        </button>
      </div>

      <div className="card">
        <h3>Selecionar evento</h3>
        <select
          className="select-evento"
          value={eventoSelecionado}
          onChange={(e) => setEventoSelecionado(e.target.value)}
          disabled={role !== "master"}
        >
          {eventos.map((ev) => (
            <option key={ev.id} value={ev.id}>
              {ev.nome}
            </option>
          ))}
        </select>
      </div>

      <div className="card">
        <h1>Contadores de Cadastros</h1>

        <p>
          <strong>Visitantes ({eventoSelecionado}) cadastrados:</strong>{" "}
          {contadorVisitantes}
        </p>

        <p>
          <strong>Expositores ({eventoSelecionado}) cadastrados:</strong>{" "}
          {contadorExpositores}
        </p>
      </div>

      <div className="card" style={{ marginTop: 30 }}>
        <h1>Exportação de Dados</h1>

        {eventoSelecionado ? (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>ID: {eventoSelecionado}</div>

          {role === "master" && (
              <button onClick={() => exportarExcel(eventoSelecionado)}>
                  📥 Exportar
              </button>
          )}
          </div>
        ) : (
          <p>Nenhum evento selecionado</p>
        )}
      </div>

      
      <div className="card" style={{ marginTop: 30 }}>
        <h2>Exportar contatos por QR Code</h2>

        <textarea
          value={codigosQR}
          onChange={(e) => setCodigosQR(e.target.value)}
          onKeyDown={(e) => {
            if (e.ctrlKey && e.key === "Enter") {
              e.preventDefault();
              exportarContatosQR();
            }
          }}
          placeholder={"VST-...\nVST-...\nEXP-..."}
          rows={8}
          style={{
            width: "100%",
            boxSizing: "border-box",
            resize: "vertical",
            padding: 12,
            marginBottom: 12,
            backgroundColor: "#1a1a1a",
            color: "#ffffff",
            border: "1px solid #333333",
            borderRadius: 6,
          }}
          />

        <button
          className="btn-primary"
          onClick={exportarContatosQR}
          disabled={loadingQR || !codigosQR.trim()}
        >
          {loadingQR ? "Gerando planilha..." : "📥 Gerar Excel de contatos"}
        </button>
      </div>


      <div className="card" style={{ marginTop: 30 }}>
        <h2>Consultar / Excluir</h2>

        <input
          placeholder="CPF"
          value={cpfBusca}
          onChange={(e) => setCpfBusca(e.target.value)}
        />

        <button className="btn-primary" onClick={buscarCPF} disabled={loadingBusca}>
          {loadingBusca ? "Buscando..." : "Buscar"}
        </button>

        {resultadosBusca.map((item) => (
          <div key={item.id}>
            <p>{item.tipo}</p>
            <p>{item.nome}</p>
            <p>{item.email}</p>
            <p>{item.cpf}</p>

          {role === "master" && (
              <button onClick={() => excluirCadastro(item)}>
                  🗑️ Excluir
              </button>
          )}
          </div>
        ))}
      </div>
    </div>
  );
}